import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { c, h } from '@debbie/cortex/dist';
import * as loadable from '@debbie/cortex/dist/Loadable/utils';
import { load } from '../connect/utils';
import Errors from '../Errors';
const IntegrationPreview = (props) => {
    const preview = useSelector((s) => s.integrationActivations[props.id]);
    const integration = useSelector((s) => {
        if (h.hasData(preview)) {
            return s.integrations[preview.data.integrationId];
        }
        return loadable.createNotLoaded();
    });
    useEffect(() => {
        if (h.isNotLoaded(preview)) {
            c.integrations.getActivation(props.id);
        }
    }, [props.id]);
    useEffect(() => {
        if (h.hasData(preview) && h.isNotLoaded(integration)) {
            c.integrations.get(preview.data.integrationId);
        }
    }, [preview]);
    return (React.createElement("div", null,
        h.isError(preview) ? React.createElement(Errors, { errors: [preview.error.message] }) : null,
        load({ preview, integration }, ({ preview, integration }) => {
            return (
            // @ts-ignore
            React.createElement(Link, { to: `/creditors/${preview.creditorId}/integrations/${preview.integrationId}` }, integration.name));
        }, 'loading')));
};
export default IntegrationPreview;
//# sourceMappingURL=IntegrationPreview.js.map